import { render, staticRenderFns } from "./utilities-water.vue?vue&type=template&id=66972d6b"
import script from "./utilities-water.vue?vue&type=script&lang=js"
export * from "./utilities-water.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports